import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// Swiper
import {Swiper, Navigation, Pagination, Autoplay, Keyboard, Thumbs} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import SwiperAnimation from '@cycjimmy/swiper-animation';
window.Swiper = Swiper

// Lazyload
import lazyLoadInit from '../../../../general/js/lazy';
lazyLoadInit();

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// fslightbox
import FsLightbox from "fslightbox";

// Fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

// Lazyload
import lazySizes from 'lazysizes';

// PureCounter
import PureCounter from "@srexi/purecounterjs";

const setupApp = ()=>
{
    lazySizes.init();
    refreshFsLightbox();

    // Fancybox
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    const pure = new PureCounter({
        formater: 'fa-IR'
    });

    let heroSwiper = new Swiper("#heroSwiper", {
        modules: [Pagination,Autoplay],
        autoplay: {
            delay: 7000,
            disableOnInteraction: false,
        },
        slidesPerView: 1,
        loop: true,
        pagination: {
            el: "#heroSwiperPagination",
        },
    });

    let shopSwiper = new Swiper("#shopSwiper", {
        slidesPerView: 1.5,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 1.3,
            },
            768: {
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: 2.8,
            },
            1280: {
                slidesPerView: 5.2,
            },
        },
    });


    let customerSwiper = new Swiper("#customerSwiper", {
        slidesPerView: 4,
        centeredSlides:true,
        centeredSlidesBounds:true,
        spaceBetween: 10,
        loop: true,
        breakpoints: {
            768: {
                slidesPerView: 4,
            },
            1024: {
                slidesPerView: 5,
            },
            1280: {
                slidesPerView: 6,
            },
        },
    });

    let blogSwiper = new Swiper("#blogSwiper", {
        slidesPerView: 1.3,
        loop: true,
        spaceBetween: 20,
        breakpoints: {
            480: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView: 3,
            },
            1280: {
                slidesPerView: 4.2,
            },
        },
    });

    let instagramSwiper = new Swiper("#instagramSwiper", {
        slidesPerView: 2.3,
        spaceBetween:0,
        breakpoints: {
            480: {
                slidesPerView: 3.5,
            },
            768: {
                slidesPerView: 5,
            },
            1024: {
                slidesPerView: 6,
            },
            1280: {
                slidesPerView: 7,
            },
        },
    });

    const element = document.querySelector('.navBar');

    window.addEventListener('scroll', () => {
        if (window.scrollY > 0) {
            element.classList.replace('beforScroll', 'afterScroll');
        } else {
            element.classList.replace('afterScroll', 'beforScroll');
        }
    });
    let productGalleryThumb = new Swiper('.product-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 3,
        breakpoints: {
            768:{
                slidesPerView: 4,
            },
        },
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    let productGallery = new Swiper('.product-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 10,
        thumbs: {
            swiper : productGalleryThumb
        },
    });

    let productRelatedItems = new Swiper('.product-related-items',  {
        slidesPerView: 1.2,
        spaceBetween: 15,
        breakpoints:{
            768:{
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView:3.3,
            },
            1280:{
                slidesPerView:4.3,
            },
        }
    });

};

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})

window.addEventListener("livewire:navigated", function(){
    window.scrollTo({top: 0, behavior: 'smooth'});
})

// console.clear();
